import { render, staticRenderFns } from "./HomeCustomer.vue?vue&type=template&id=427a66b4&scoped=true"
import script from "./HomeCustomer.vue?vue&type=script&lang=js"
export * from "./HomeCustomer.vue?vue&type=script&lang=js"
import style0 from "./HomeCustomer.vue?vue&type=style&index=0&id=427a66b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427a66b4",
  null
  
)

export default component.exports